import classNames from "classnames";
import styles from "../styles/login.module.scss";
import {observer} from "mobx-react";
import {shareState} from "../../../app/share-state";
import {useEffect, useRef} from "react";

export const LoginWidgetPrivacyAndPolicy = observer(({controller}) => {
  const {
    state: {
      shouldRenderRegistrationPage,
      privacyAndPolicyValue,
      showErrorUnCheckedBoxMessage,
      isDominos,
      shouldShowCheckbox
    }
  } = controller;
  const ref = useRef();

  const checkboxProps = {
    type: "checkbox",
    checked: privacyAndPolicyValue,
    className: classNames(styles.checkbox),
    onChange: (e) => controller.setPrivacyAndPolicy(e.target.checked)
  }

  const onClick = (url) => {
    shareState.isWebView ? shareState.nativeFunctionsUtils.callFunction("openBrowser", {url}) : window.open(url);
  }

  useEffect(() => {

    const children = ref.current?.children;
    if (children) {
      const arr = [].slice.call(children);

      arr?.forEach((child) => child.onclick = () => onClick(child.dataset.url))
    }
  }, [shouldRenderRegistrationPage]);


  const termsAndPolicyProps = {
    className: classNames(styles.terms_and_policy, {[styles.hide_checkbox]: isDominos || !shouldShowCheckbox}),
    dangerouslySetInnerHTML: {
      __html: shareState.termsUtils.terms.WC_2022_LOGIN_ACCEPT_TERMS_AND_CONDITIONS
        .replaceAll('<a', '<div')
        .replaceAll('</a>', '</div>')
        .replaceAll('href', 'data-url')
    },
    ref
  }

  return (
    <div className={classNames(styles.user_agreements_container)}>
      <div className={classNames(styles.user_agreements)}>
        {
          !isDominos && shouldShowCheckbox ? <input {...checkboxProps}/> : null
        }
        <div {...termsAndPolicyProps}/>
      </div>
      {
        showErrorUnCheckedBoxMessage ? (<div className={classNames(styles.error_message)}>
          {
            showErrorUnCheckedBoxMessage
          }
        </div>) : null
      }
    </div>
  )
});
